export default __webpack_public_path__ + "static/media/Emerald Croc-hide Gloves.e2d9a461.jpg";